import LazyLoad from 'vanilla-lazyload';
import Bubbles from './components/dataviz/Bubbles';
import DataViz from './components/dataviz/Dataviz';
import DatavizSwitcher from './components/dataviz/DatavizSwitcher';
import FontFace from './components/FontFace';
import Glossaire from './components/Glossaire';
import OffCanvas from './components/OffCanvas';
import SearchSuggestJS from './components/Search';
import { SEO } from './components/Seo';
import StickyHeader from './components/Sticky';
import SwiperJS from './components/swiper';
import ContactJs from './components/Contact';

// Load our project JavaScript dependencies.
require('./utils/Boostrap');

function initLazyLoad() {
  new LazyLoad({
    elements_selector: '.lazy',
  });

  // This lazyload instance is just a hack to trigger callbacks when .aos enter screen
  const aos = new LazyLoad({
    elements_selector: '.aos',
    callback_enter: (el) => {
      const delay = el.getAttribute('data-aos-delay');
      if (!delay) {
        el.classList.add('visible');
      } else {
        window.setTimeout(() => {
          el.classList.add('visible');
        }, delay);
      }
    },
    // By default, vanilla-lazyload does its magic just before elements actually enters the screen.
    // We don't want our animation to trigger until element is fully visible
    // so we're setting the threshold params to a negative number
    threshold: 0,
  });

  return aos;
}

function ie11redirect() {
  // eslint-disable-next-line
  var isIe11 = !!window.MSInputMethodContext && !!document.documentMode;
  // eslint-disable-next-line
  var currentPath = document.location.pathname;

  if (currentPath === '/navigateur-incompatible') {
    return;
  }

  if (isIe11) {
    document.location.href = '/navigateur-incompatible';
  }
}

/**
 * Fire up everything 🚀
 */
document.addEventListener('DOMContentLoaded', () => {
  new FontFace();

  const aos = initLazyLoad(); // eslint-disable-line

  ie11redirect();

  // Tarteaucitron init
  window.tarteaucitron.init({
    adblocker: false,
    hashtag: '#tarteaucitron',
    cookieName: 'tarteaucitron',
    bodyPosition: 'bottom',
    moreInfoLink: true,
    privacyUrl: '/chartes-cookies',
    orientation: 'bottom',
    showAlertSmall: false,
    cookieslist: false,
    acceptAllCta: true,
    denyAllCta: true,
    highPrivacy: true,
    handleBrowserDNTRequest: false,
    removeCredit: true,
    useExternalCss: false,
    useExternalJs: false,
  });
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line
  window.tarteaucitron.user.googletagmanagerwithfallbackId = document.querySelector('body').getAttribute('data-tac-ga');
  // eslint-disable-next-line
  (window.tarteaucitron.job = window.tarteaucitron.job || []).push('googletagmanagerwithfallback');

  // Autocomplete off-canvas menu
  new SearchSuggestJS({
    input: '.js-search-suggest',
    parentEl: '.input-search-menu',
    minChars: 2,
  });

  new SearchSuggestJS({
    input: '.js-search-suggest-results',
    parentEl: '.search-hero-cta-container',
    minChars: 2,
  });

  new StickyHeader();
  new DataViz();
  new Bubbles();
  new Glossaire();
  new SEO();
  new SwiperJS();
  new ContactJs();

  if (document.querySelector('body.product')) {
    const tab = document.querySelector('[data-tab=ingredients]');

    if (tab) {
      tab.click();
      setTimeout(document.querySelector('#bloc_product').style.opacity = 1, 500);
    }
  }

  // Switcher needs to be initialized after bubbles are created
  new DatavizSwitcher();

  OffCanvas();
});
